import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogTitle, Grid, MuiThemeProvider, Switch, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Close as CloseIcon, InfoOutlined } from '@material-ui/icons';
import { IoMdCheckmark, IoMdCloseCircleOutline } from 'react-icons/io';

import TableCustom from '../../../../Components/Table';
import LoadingButton from '../../../../Components/LoadingButton';


import { atualizarRelacaoCnisFontesPagadoras, buscarRelacaoCnisFontesPagadoras } from '../../../../Store/Actions/API/relacoesPrevidenciariasActions';
import temaFormulario from '../../../../Styles/Temas/temaFormulario';
import { useStyles } from './styles';
import { formatarReais } from '../../../../Utils/utils';

export default function ModalRevisarRetencoes({ cpf, relacaoSelecionada, open, fechar }) {

    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setLoading] = useState(false);
    const [isLoadingConfirmar, setLoadingConfirmar] = useState(false);

    const [retencoes, setRetencoes] = useState([]);
    const [houveAlteracao, setHouveAlteracao] = useState(false);
    const [bloquearConfirmacao, setBloquearConfirmacao] = useState(false);

    useEffect(() => {
        lidarListaRetencoes();
    }, []); // eslint-disable-line

    const lidarListaRetencoes = async () => {
        setLoading(true);

        const filtros = { idRelacao: relacaoSelecionada.id, cpf };

        const response = await buscarRelacaoCnisFontesPagadoras(filtros);

        setLoading(false);

        if (response === null) {
            fechar();
            return;
        } else {
            setRetencoes(response.retencoes ?? response);

            setBloquearConfirmacao(response.bloquearConfirmacao ?? false);
        }
    }

    const clicaConfirmar = async () => {
        setLoadingConfirmar(true);
        let response = await atualizarRelacaoCnisFontesPagadoras({ cpf: cpf, listaCnisFontes: Object.assign([], retencoes) });
        setLoadingConfirmar(false);
        if (response.sucesso) {
            fechar(true);
        }
    }

    const clicaFechar = () => {
        if(!isLoadingConfirmar){
            fechar();
        }
    }

    const clicaMarcarTodos = () => {
        let retencoesTmp = Object.assign([], retencoes);
        retencoesTmp = retencoesTmp.map((retencao) => {
            return { ...retencao, considerarApuracao: true };
        })
        setRetencoes(Object.assign([], retencoesTmp));
        setHouveAlteracao(true);
    }

    const clicaDesmarcarTodos = () => {
        let retencoesTmp = Object.assign([], retencoes);
        retencoesTmp = retencoesTmp.map((retencao) => {
            return { ...retencao, considerarApuracao: false };
        })
        setRetencoes(Object.assign([], retencoesTmp));
        setHouveAlteracao(true);
    }

    const onChangeConsiderarApuracao = (id) => {
        let index = retencoes.findIndex(x => x.id === id);

        if (index !== -1) {
            let retencoesTmp = Object.assign([], retencoes);
            retencoesTmp[index].considerarApuracao = !retencoesTmp[index].considerarApuracao;
            setRetencoes(Object.assign([], retencoesTmp));
            setHouveAlteracao(true);
        }
    }

    const columns = [
        {
            title: "Ano Calendário",
            dataIndex: "competencia",
            key: "competencia",
            align: "center",
            width: 80,
            render: (value, row) => <p style={{ fontSize: 13 }}>{`${value}`}</p>,
        },
        {
            title: "Retenção INSS apurado",
            dataIndex: "retencaoINSSApurado",
            key: "retencaoINSSApurado",
            align: "center",
            width: 100,
            render: (value, row) => <p style={{ fontSize: 13 }}>{`${formatarReais(value)}`}</p>,
        },
        {
            title: "Retenção INSS Fontes Pagadoras",
            dataIndex: "retencaoINSSFontesPagadoras",
            key: "retencaoINSSFontesPagadoras",
            align: "center",
            width: 125,
            render: (value, row) => value === '-' ?
                <IoMdCloseCircleOutline color='red' size={20} />
                : <p style={{ fontSize: 13 }}>{`${formatarReais(value)}`}</p>,
        },
        {
            title: "Diferença INSS",
            dataIndex: "diferencaINSS",
            key: "diferencaINSS",
            align: "center",
            width: 125,
            render: (value, row) => Number(value) === 0 ?
                <IoMdCheckmark color='#24bd09' size={20} /> :
                <p style={{ fontSize: 13 }}>{value === '-' ? value : `${Number(value) < 0 ? '-' : ''}${formatarReais(value)}`}</p>,
        },
        {
            title: "Considerar na Apuração",
            dataIndex: "considerarApuracao",
            key: "considerarApuracao",
            align: "center",
            headerRender: (title) => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
                <Switch size={'small'} disabled={isLoadingConfirmar} className={classes.switch}
                    onChange={() => {
                        if (retencoes.find(x => !x.considerarApuracao)) {
                            clicaMarcarTodos();
                        } else {
                            clicaDesmarcarTodos();
                        }
                    }}
                    checked={(retencoes.filter(x => x.considerarApuracao).length > 0 &&
                        retencoes.filter(x => x.considerarApuracao).length === retencoes.length)} />
            </div>,
            render: (value, row) => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Typography style={{ fontSize: 13, paddingTop: 3, paddingRight: 3 }}>Não</Typography>
                <Switch disabled={isLoadingConfirmar} size={'small'} className={classes.switch} onChange={() => onChangeConsiderarApuracao(row.id)} checked={row.considerarApuracao} />
                <Typography style={{ fontSize: 13, paddingTop: 3, paddingLeft: 2 }}>Sim</Typography>
            </div>
        }
    ];

    const propsTable = {
        columns,
        data: retencoes,
        heightBody: "400px",
        minHeightBody: "180px",
        removeHeaderBackground: true,
        marginBorder: true,
        width: '100%',
        elevationPaper: 0,
        useLoading: true,
        loading: isLoading
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth={"md"}
            open={open}
            onClose={clicaFechar}
            aria-labelledby="modal-revisar-retencoes"
        >
            <MuiThemeProvider theme={temaFormulario}>
                <DialogTitle id="modal-revisar-retencoes" style={{ backgroundColor: '#D4BFF9' }}>
                    <Grid container alignItems='center'>
                        <Grid item>
                            <Typography style={{ fontWeight: 700 }}>
                                {"CNIS X FONTES PAGADORAS"}
                            </Typography>
                        </Grid>
                        <Grid item style={{ marginLeft: 10 }}>
                            <Tooltip title={<Typography style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', fontSize: 15 }}>
                                {`Este alerta é disparado quando o valor das retenções previdenciárias calculadas pelo sistema está divergente do valor informado na DIRF pela fonte pagadora.

                            Importante ressaltar que pequenas diferenças entre o valor calculado pelo sistema e o valor declarado pela fonte pagadora são aceitáveis, uma vez que na DIRF as retenções podem ser informadas pelo regime de caixa e não de competência.`}
                            </Typography>} arrow placement='bottom'>
                                <InfoOutlined fontSize='small' style={{ float: 'right', cursor: 'pointer' }}>
                                    <InfoOutlined fontSize='small' />
                                </InfoOutlined>
                            </Tooltip>
                        </Grid>
                        <div style={{ flexGrow: 1 }} />
                        <Grid item>
                            <CloseIcon style={{ float: 'right', cursor: 'pointer' }} onClick={() => clicaFechar()}>
                                <CloseIcon />
                            </CloseIcon>
                        </Grid>
                    </Grid>
                </DialogTitle>
            </MuiThemeProvider>
            <div className={classes.mainContent}>
                {
                    (retencoes.length > 0 || isLoading) ? (
                        <TableCustom {...propsTable} />

                    ) : (
                        <div style={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', display: 'flex', height: 200, width: '100%', fontSize: "calc(10px + 2vmin)" }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ paddingTop: 3, paddingRight: 5 }}><CloseIcon /> </div> Nenhum registro encontrado
                            </div>

                        </div>
                    )
                }
            </div>
            <MuiThemeProvider theme={temaFormulario}>
                <DialogActions id="modal-revisar-retencoes" style={{ paddingRight: 20, paddingBottom: 15 }}>
                    <LoadingButton
                        id="button_confirmar"
                        variant="contained"
                        color="primary"
                        size='small'
                        disabled={((!houveAlteracao && !retencoes.find(x => !x.confirmacaoRealizada)) || (bloquearConfirmacao))}
                        onClick={clicaConfirmar}
                        loading={isLoadingConfirmar}
                        disableElevation
                    >
                        Confirmar
                    </LoadingButton>                   
                </DialogActions>
            </MuiThemeProvider>
        </Dialog>
    )
}